/* unplugin-vue-components disabled */import script from "./Notice.vue?vue&type=script&setup=true&lang=js"
export * from "./Notice.vue?vue&type=script&setup=true&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=2d0b196d&lang=scss&scoped=true"
import "./Notice.vue?vue&type=style&index=1&id=2d0b196d&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d0b196d"]])

export default __exports__